// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedFocusTip_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10 16C10 17.1046 9.10457 18 8 18C6.89543 18 6 17.1046 6 16C6 14.8954 6.89543 14 8 14C9.10457 14 10 14.8954 10 16Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9 8V10.083C11.5125 10.5045 13.4955 12.4875 13.917 15H16V17H13.917C13.4955 19.5125 11.5125 21.4955 9 21.917V24H7V21.917C4.4875 21.4955 2.50448 19.5125 2.08296 17H0V15H2.08296C2.50448 12.4875 4.4875 10.5045 7 10.083V8H9ZM8 20C10.2091 20 12 18.2091 12 16C12 13.7909 10.2091 12 8 12C5.79086 12 4 13.7909 4 16C4 18.2091 5.79086 20 8 20Z" class="svg-bg"/>
  <path d="M4 8H0V12H2V10H4V8ZM0 20H2L2 22H4L4 24H0V20ZM12 24V22H14V20H16V24H12ZM16 12 14 12 14 10 12 10V8H16V12Z" class="svg-bg"/>
  <path opacity=".5" d="M24 0H21.6L8 16L24 0Z" class="svg-bg"/>
</svg>
`;
const _s40IconSvg = html `<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M10 22H8V24.0709C4.93431 24.5094 2.5094 26.9343 2.07089 30H0V32H2.07089C2.5094 35.0657 4.93431 37.4906 8 37.9291V40H10V37.9291C13.0657 37.4906 15.4906 35.0657 15.9291 32H18V30H15.9291C15.4906 26.9343 13.0657 24.5094 10 24.0709V22ZM14 31C14 33.7614 11.7614 36 9 36C6.23858 36 4 33.7614 4 31C4 28.2386 6.23858 26 9 26C11.7614 26 14 28.2386 14 31ZM9 33C10.1046 33 11 32.1046 11 31C11 29.8954 10.1046 29 9 29C7.89543 29 7 29.8954 7 31C7 32.1046 7.89543 33 9 33ZM2 22H0V24V26H2V24H4V22H2ZM0 40V38V36H2V38H4V40H2H0ZM16 40H18V38V36H16V38H14V40H16ZM18 22V24V26H16V24H14V22H16H18Z" class="svg-bg"/>
  <path opacity=".5" d="M35.6151 0L31.658 6.51565L32.3329 7.1905L9 30.9996L33.6797 8.53734L34.4732 9.33087L39.9999 6.78976V4.58848L34.9029 6.93205L34.1825 6.21174L37.9551 0H35.6151Z" class="svg-bg"/>
</svg>
`;
const _s48IconSvg = html `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9 28H11V30.0619C14.6187 30.5131 17.4869 33.3813 17.9381 37H20V39H17.9381C17.4869 42.6187 14.6187 45.4869 11 45.9381V48H9V45.9381C5.38128 45.4869 2.51314 42.6187 2.06189 39H0V37H2.06189C2.51314 33.3813 5.38128 30.5131 9 30.0619V28ZM16 38C16 41.3137 13.3137 44 10 44C6.68629 44 4 41.3137 4 38C4 34.6863 6.68629 32 10 32C13.3137 32 16 34.6863 16 38ZM12 38C12 39.1046 11.1046 40 10 40C8.89543 40 8 39.1046 8 38C8 36.8954 8.89543 36 10 36C11.1046 36 12 36.8954 12 38ZM0 32V30V28H2H4V30H2V32H0ZM20 30V28H18H16V30H18V32H20V30ZM0 46V48H2H4V46H2V44H0V46ZM18 48H20V46V44H18V46H16V48H18Z" class="svg-bg"/>
  <path opacity=".5" fill-rule="evenodd" clip-rule="evenodd" d="M42.3599 0L38.0362 7.11923L37.6287 7.79027L38.1838 8.34542L38.6744 8.83598L10 38L40.0593 10.2209L40.4096 10.5712L40.9019 11.0635L41.5345 10.7726L47.9998 7.79995V5.59867L41.3315 8.66468L40.1532 7.48636L44.6998 0H42.3599Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedFocusTip is a generated icon component.
 */
let IconMedFocusTip = IconMedFocusTip_1 = class IconMedFocusTip extends IconBaseElement {
    render() {
        return html `${IconMedFocusTip_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedFocusTip.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s40IconSvg],
    ['s40', _s40IconSvg],
    ['s48', _s48IconSvg],
    ['s64', _s48IconSvg],
    ['s72', _s48IconSvg],
    ['s80', _s48IconSvg],
]);
IconMedFocusTip = IconMedFocusTip_1 = __decorate([
    customElement('zui-icon-med-focus-tip')
], IconMedFocusTip);
export { IconMedFocusTip };
